import HeroBg from "@/assets/img/palmistry/result/palmistry_head.webp"
import HealthIcon from "@/assets/svg/palmistry/result/health.svg?react"
import SuccessIcon from "@/assets/svg/palmistry/result/success.svg?react"
import RomanceIcon from "@/assets/svg/palmistry/result/romance.svg?react"
import CareerIcon from "@/assets/svg/palmistry/result/career.svg?react"

import type { FunctionComponent, SVGProps } from "react"

import { palmCopy } from "../config/copy"
import { formatReportDate } from "../lib/format-report-date"
import type { PalmReading } from "../types"
import { ArcGauge } from "./arc-gauge"

type SvgComponent = FunctionComponent<SVGProps<SVGSVGElement>>

interface PalmHeroProps {
  reading: PalmReading
}

/** Palm result header: illustration, title, and four life-area gauges. Ported from Hero. */
export function PalmHero({ reading }: PalmHeroProps) {
  return (
    <div className="flex flex-col items-center text-center">
      <div className="relative mx-auto flex max-h-[364px] w-full max-w-app items-center justify-center overflow-hidden">
        <img
          src={HeroBg}
          alt=""
          className="pointer-events-none max-h-full max-w-full object-contain"
        />
      </div>
      <h1 className="font-display text-[40px] font-medium text-purple-light">{palmCopy.title}</h1>
      <p className="mt-1 font-body text-sm text-purple-light/70">
        {palmCopy.subtitle(formatReportDate(reading.lastUpdated, "short"))}
      </p>

      <div className="mt-4 flex w-full flex-wrap justify-between gap-y-2 px-4">
        <StatCard Icon={HealthIcon} label="HEALTH" value={reading.health.percent} color="#50E3C2" />
        <StatCard
          Icon={SuccessIcon}
          label="SUCCESS"
          value={reading.success.percent}
          color="#FFC014"
        />
        <StatCard
          Icon={RomanceIcon}
          label="ROMANCE"
          value={reading.relationship.percent}
          color="#FF537F"
        />
        <StatCard Icon={CareerIcon} label="CAREER" value={reading.career.percent} color="#7FE718" />
      </div>
    </div>
  )
}

interface StatCardProps {
  Icon: SvgComponent
  label: string
  value: number
  color: string
}

function StatCard({ Icon, label, value, color }: StatCardProps) {
  return (
    <div className="relative flex max-h-28 flex-col items-center">
      <ArcGauge value={value} ratio={0.6} size={80} strokeWidth={7} stroke={color}>
        <span className="[&_svg]:size-8">
          <Icon />
        </span>
      </ArcGauge>
      <div className="relative bottom-5 w-full">
        <span
          className="inline-block rounded-[13px] px-2 py-1.5 font-body text-[10px] font-medium uppercase"
          style={{ backgroundColor: `${color}33`, color }}
        >
          {label}
        </span>
        <p className="mt-0.5 font-display text-xl font-medium text-purple-light">{value}%</p>
      </div>
    </div>
  )
}
